var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer ce produit ?")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$store.state.single.data.label))])])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-672aa3fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/Delete.vue
// module id = null
// module chunks = 